import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { RootScopeDeclare } from '../../../../src/app/core/rootscope-declare';
import { RootScopeService } from '../../../../src/app/core/shared-service/root-scope.service';
import { environment } from '../../../../src/environments/environment';
import { DeprecatedConsole, DeprecatedFeatureType } from './deprecated-banner.interface';
@Component({
  selector: 'app-deprecated-banner',
  templateUrl: './deprecated-banner.component.html',
  styleUrls: ['./deprecated-banner.component.scss'],
  providers: [CommonModule],
})
export class DeprecatedBannerComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() description: string;
  @Input() deprecatedConsoles: DeprecatedConsole[];
  @Input() deprecatedFeatureType: DeprecatedFeatureType = DeprecatedFeatureType.FeatureSupportUpdate;
  public cloudBasePath: string = environment.cloudBasePath;
  public rootScopeData: RootScopeDeclare;
  public type = DeprecatedFeatureType;
  private sub = new Subscription();
  constructor(private rootScopeService: RootScopeService) {}

  ngOnInit(): void {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    const rootScopeSub = this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
    });
    this.sub.add(rootScopeSub);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
